var React = require('react');

function NodeCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 48A24 24 0 1124-.001 24 24 0 0124 48zm0-46a22 22 0 100 44 22 22 0 000-44z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.487 13.566A2.34 2.34 0 0016 14.998V30h-2a4 4 0 104 4V20.781l14-4.375V25h-2a4 4 0 104 4V9.89a1.77 1.77 0 00-.73-1.39l-.14-.08a1.69 1.69 0 00-1.5-.05l-13.88 4.36a2.34 2.34 0 00-1.263.836zM32 10.36l-13.7 4.29a.37.37 0 00-.3.35v3.64l14-4.37v-3.91zM30 27a2 2 0 102 2v-2h-2zm-17.111 5.337A2 2 0 0114 32h2v2a2 2 0 11-3.111-1.663z","key":1})]);
}

NodeCircle.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = NodeCircle;

NodeCircle.default = NodeCircle;
